import { CommunicationService } from '../services/communication.service'
// @ts-ignore
import { LocalStorageService, APPS as APP_INFO } from '@cosmos/utilities';
import { navigateToUrl } from 'single-spa';

export class LogoutEvent {
  readonly EVENT_NAME = 'requestLogout'
  static logoutEvent: LogoutEvent

  private constructor() {
    this.load()
  }

  static init(): LogoutEvent {
    if (!LogoutEvent.logoutEvent) {
        LogoutEvent.logoutEvent = new LogoutEvent()
    }
    return LogoutEvent.logoutEvent
  }

  static destroy() {}

  load() {
    const communicationService = CommunicationService.singleton()
    communicationService.receiveCustomEvent(
      this.EVENT_NAME,
      this.logout
    )
  }

  logout: EventListener = async (event: CustomEvent) => {
    const appView = localStorage.getItem('appView')
    if (appView) {
      window.parent.postMessage({ listener: 'iframe_component', message: 'back' },'*');
      return
    }
    const localStorageService = LocalStorageService.singleton()
    localStorageService.clearAll()
    localStorageService.setSystemAtivoToken(APP_INFO['plataforma'].chave_sistema)
    window.location.href = "/"
  }
}
